import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { PRIVILEGE_FETCH, PRIVILEGES_FETCH, PRIVILEGES_FETCH_ALL } from "../actions/types";
import {
  privilegeFetchSuccess,
  privilegesFetchSuccess,
  showErrorMessage,
  authSignOutSuccess,
} from "../actions";
import { authorizationHeader, getErrorMessage_v2 } from "../utils/apiUtil";
import axios from "axios";
import axiosRetry from "axios-retry";
import { checkLogin } from "../utils/apiUtil";
axiosRetry(axios, {
  retries: 3,
  retryDelay: (retryCount) => {
    return retryCount * 1000;
  },
});

const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

// API
const privilegeFetchRequest = async (payload) => {
  return await axios
    .get(`${REACT_APP_API_URL}/client/v1/privileges/${payload}`, {
      headers: authorizationHeader("Bearer"),
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

const privilegesFetchRequest = async (payload) => {
  return await axios
    .get(`${REACT_APP_API_URL}/client/v1/privileges`, {
      headers: authorizationHeader("Bearer"),
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

const privilegesAllFetchRequest = async (payload) => {
  return await axios
    .get(`${REACT_APP_API_URL}/client/v1/privilegesAllActive`, {
      headers: authorizationHeader("Bearer"),
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

const hotPrivilegesFetchRequest = async (payload) => {
  return await axios
    .get(`${REACT_APP_API_URL}/client/v1/hot-privileges`, {
      headers: authorizationHeader("Bearer"),
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

// WORKER
function* privilegeFetch({ payload }) {
  let dataFav = { length: 0, list: [] };
  try {
    dataFav = yield call(privilegeFetchRequest, payload);
  } catch {}

  try {
    let data = yield call(privilegeFetchRequest, payload);
    if (dataFav.length === 0) {
      data.fav = "disable";
    } else {
      data.fav = dataFav.enable_status;
    }

    yield put(privilegeFetchSuccess(data));
  } catch (error) {
    if (
      error.response &&
      error.response.status &&
      error.response.status === 401
    ) {
      localStorage.removeItem("member");
      yield put(authSignOutSuccess());
    } else {
      yield put(showErrorMessage(getErrorMessage_v2(error.response)));
    }
  }
}

function* privilegesFetch({ payload }) {
  let dataFav = { list: [] };

  if (checkLogin() === true) {
    try {
      dataFav = yield call(privilegesFetchRequest, payload);
    } catch {}
  }

  try {
    let privilegeData = [];
    let data = yield call(privilegesFetchRequest, payload);
    let hotPrivilege = yield call(hotPrivilegesFetchRequest, payload);
    privilegeData.count = parseInt(data.count) + parseInt(hotPrivilege.count);
    privilegeData.list = data.list;
    for (let index = 0; index < hotPrivilege.list.length; index++) {
      for (let idx = 0; idx < privilegeData.list.length; idx++) {
        if (
          hotPrivilege.list[index].privilege_id === privilegeData.list[idx].id
        ) {
          privilegeData.list[idx].type = "hot";
        }
      }
       privilegeData.list.push(hotPrivilege.list[index]);
    }

    if (checkLogin() === true) {
      for (let i = 0; i < data.list.length; i++) {
        if (dataFav.list.length !== 0) {
          data.list[i].fav = "disable";
          for (let x = 0; x < dataFav.list.length; x++) {
            if (
              parseInt(data.list[i].id) ===
              parseInt(dataFav.list[x].privilege_id)
            ) {
              data.list[i].fav = "enable";
            }
          }
        } else {
          data.list[i].fav = "disable";
        }
      }
    }
    yield put(privilegesFetchSuccess(privilegeData));
  } catch (error) {
    if (
      error.response &&
      error.response.status &&
      error.response.status === 401
    ) {
      localStorage.removeItem("member");
      yield put(authSignOutSuccess());
    } else {
      yield put(showErrorMessage(getErrorMessage_v2(error.response)));
    }
  }
}

function* privilegesFetchs({ payload }) {
  let dataFav = { list: [] };

  if (checkLogin() === true) {
    try {
      dataFav = yield call(privilegesAllFetchRequest, payload);
    } catch {}
  }

  try {
    let privilegeData = [];
    let data = yield call(privilegesAllFetchRequest, payload);
    let hotPrivilege = yield call(hotPrivilegesFetchRequest, payload);
    privilegeData.count = parseInt(data.count) + parseInt(hotPrivilege.count);
    privilegeData.list = data.list;
    for (let index = 0; index < hotPrivilege.list.length; index++) {
      for (let idx = 0; idx < privilegeData.list.length; idx++) {
        if (
          hotPrivilege.list[index].privilege_id === privilegeData.list[idx].id
        ) {
          privilegeData.list[idx].type = "hot";
        }
      }
       privilegeData.list.push(hotPrivilege.list[index]);
    }

    if (checkLogin() === true) {
      for (let i = 0; i < data.list.length; i++) {
        if (dataFav.list.length !== 0) {
          data.list[i].fav = "disable";
          for (let x = 0; x < dataFav.list.length; x++) {
            if (
              parseInt(data.list[i].id) ===
              parseInt(dataFav.list[x].privilege_id)
            ) {
              data.list[i].fav = "enable";
            }
          }
        } else {
          data.list[i].fav = "disable";
        }
      }
    }
    yield put(privilegesFetchSuccess(privilegeData));
  } catch (error) {
    if (
      error.response &&
      error.response.status &&
      error.response.status === 401
    ) {
      localStorage.removeItem("member");
      yield put(authSignOutSuccess());
    } else {
      yield put(showErrorMessage(getErrorMessage_v2(error.response)));
    }
  }
}

// WATCHER
function* privilegeFetchWatcher() {
  yield takeEvery(PRIVILEGE_FETCH, privilegeFetch);
}
function* privilegesFetchWatcher() {
  yield takeEvery(PRIVILEGES_FETCH, privilegesFetch);
}

function* privilegesFetchAllWatcher() {
  yield takeEvery(PRIVILEGES_FETCH_ALL, privilegesFetchs);
}

export default function* rootSaga() {
  yield all([fork(privilegeFetchWatcher)]);
  yield all([fork(privilegesFetchWatcher)]);
  yield all([fork(privilegesFetchAllWatcher)]);
}
